import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import { LoginForm } from './LoginForm'
import { OTPForm } from './OTPForm'
import { isLoggedIn, otpSendState, useAuthApi } from 'services/auth'

import '../../base.style.css'
import './auth.style.css'

export const AuthWrapper = () => {
  const navigate = useNavigate()

  const { sendOtpApi, verifyOtpApi } = useAuthApi()
  const { sent, phone, otp } = useRecoilValue(otpSendState)
  const isLogin = useRecoilValue(isLoggedIn)

  useEffect(() => {
    if (isLogin) navigate('/panel/menu')
  }, [isLogin, navigate])

  const handleOnSubmitPhonePress = useCallback(
    async (phoneNumber: number) => {
      await sendOtpApi.sendOTP(phoneNumber)
    },
    [sendOtpApi]
  )

  const handleOnSubmitOTP = useCallback(
    async (code: string) => {
      await verifyOtpApi.verifyOTP({ code, phone })
    },
    [phone, verifyOtpApi]
  )

  const handleOnResendOTP = useCallback(async () => {
    await sendOtpApi.sendOTP(phone)
  }, [phone, sendOtpApi])

  const renderContent = useCallback(() => {
    if (sent) {
      return (
        <OTPForm
          otp={otp}
          isLoading={verifyOtpApi.isLoading || sendOtpApi.isLoading}
          handleOnSubmit={handleOnSubmitOTP}
          handleOnResend={handleOnResendOTP}
        />
      )
    }

    return <LoginForm onSubmit={handleOnSubmitPhonePress} isLoading={sendOtpApi.isLoading} />
  }, [
    handleOnResendOTP,
    handleOnSubmitOTP,
    handleOnSubmitPhonePress,
    otp,
    sendOtpApi.isLoading,
    sent,
    verifyOtpApi.isLoading,
  ])

  return <div className="auth-wrapper center">{renderContent()}</div>
}
